import React, { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import './Header.css';

import AtmosBackground from '../assets/videos/ATMOS LOOP EDGE DETECT CRT BLOOM.mp4';
import FacebookIcon from '../assets/images/Facebook-logo-36.svg';
import InstagramIcon from '../assets/images/Instagram-logo-36.svg';
import TiktokLogo from '../assets/images/tiktok-logo-png.svg';
import SoundcloudLogo from '../assets/images/soundcloud-logo_36.svg';
import YoutubeLogo from '../assets/images/youtube-logo-36.svg';

const Header = () => {
  const [menuOpen, setMenuOpen] = useState(false);
  const videoRef = useRef(null);

  // Autoplay workaround for iOS
  useEffect(() => {
    const video = videoRef.current;

    if (video) {
      video.loop = true;
      video.muted = true;
      video.playsInline = true;
      video.preload = 'auto';
      video.load();

      // Attempt autoplay after slight delay
      setTimeout(() => {
        const playPromise = video.play();
        if (playPromise !== undefined) {
          playPromise.catch((err) => {
            console.warn('Autoplay failed:', err);
          });
        }
      }, 100);
    }

    // Manual fallback: play after first interaction
    const tryPlay = () => {
      if (video && video.paused) {
        video.play().catch((err) => {
          console.warn('Manual play failed:', err);
        });
      }
    };

    document.addEventListener('touchstart', tryPlay, { once: true });
    document.addEventListener('click', tryPlay, { once: true });

    return () => {
      document.removeEventListener('touchstart', tryPlay);
      document.removeEventListener('click', tryPlay);
    };
  }, []);

  return (
    <div className="header">
      
      <video
        ref={videoRef}
        className="background-video"
        src={AtmosBackground}
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      />

      {/* Center Title */}
      <div className="center-title">
  <h1 className="logo-title">ATMOS</h1>
</div>


      {/* Social Sidebar */}
      <div className="sidebar">
        <a href="https://www.facebook.com/atmos.nz" target="_blank" rel="noopener noreferrer">
          <img src={FacebookIcon} alt="Facebook" />
        </a>
        <a href="https://www.instagram.com/atmos_wlg" target="_blank" rel="noopener noreferrer">
          <img src={InstagramIcon} alt="Instagram" />
        </a>
        <a href="https://www.tiktok.com/@atmos_wlg" target="_blank" rel="noopener noreferrer">
          <img src={TiktokLogo} alt="TikTok" />
        </a>
        <a href="https://soundcloud.com/atmos-501871607" target="_blank" rel="noopener noreferrer">
          <img src={SoundcloudLogo} alt="SoundCloud" />
        </a>
        <a href="https://www.youtube.com/@atmos_nz" target="_blank" rel="noopener noreferrer">
          <img src={YoutubeLogo} alt="YouTube" />
        </a>
      </div>

      {/* Desktop Menu */}
      <div className="menu desktop-menu">
        <ul>
          <li><Link to="/events">EVENTS +</Link></li>
          <li><Link to="/contact">CONTACT US +</Link></li>
          <li><Link to="/about">ABOUT US +</Link></li>
          <li><Link to="/The Team">THE TEAM +</Link></li>
        </ul>
      </div>

      {/* Mobile Hamburger */}
      <button
        className={`hamburger-icon ${menuOpen ? 'open' : ''}`}
        onClick={() => setMenuOpen(!menuOpen)}
        aria-label="Toggle menu"
      >
        <span className="bar"></span>
        <span className="bar"></span>
        <span className="bar"></span>
      </button>

      {/* Mobile Fullscreen Menu */}
      <div className={`fullscreen-menu ${menuOpen ? 'open' : ''}`}>
        <ul className="fullscreen-links">
          <li><Link to="/events" onClick={() => setMenuOpen(false)}>EVENTS +</Link></li>
          <li><Link to="/contact" onClick={() => setMenuOpen(false)}>CONTACT US +</Link></li>
          <li><Link to="/about" onClick={() => setMenuOpen(false)}>ABOUT US +</Link></li>
          <li><Link to="/The Team" onClick={() => setMenuOpen(false)}>THE TEAM +</Link></li>
        </ul>
      </div>
    </div>
  );
};

export default Header;
